import {
  CentraCheckoutApiMappers,
  centraCheckoutApiProductToGreaseProductBase,
} from "@made-people/grease-centra";

export const mmProductBase: CentraCheckoutApiMappers["centraCheckoutApiProductToGreaseProductBase"] =
  (product, options, mappers) => {
    return {
      ...centraCheckoutApiProductToGreaseProductBase(product, options, mappers),
      discontinued: product.discontinued_bool === "1",
    };
  };
